import { getGeoValueByType, getTermValue } from '../../../packages/JsonQuery';
import { IAppState } from '../../common/state';
import { EBuildingStatus } from '../../repositories/common/json_query';

export function getIsHousesFilterEnabled({ results: { jsonQuery } }: IAppState): boolean {
  const isFromDeveloper = getTermValue('from_developer')(jsonQuery);
  const isNewobject = getGeoValueByType('newobject')(jsonQuery);
  const buildingStatus = getTermValue('building_status')(jsonQuery);

  return Boolean(buildingStatus === EBuildingStatus.New || (isFromDeveloper && isNewobject));
}
